/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { History as BrowserHistory } from 'history';
import { withRouter, type RouteContext } from '@atlassian/react-resource-router';
import LastVisitedProjectPageRedirect from './LastVisitedProjectPageRedirect.tsx';

const defaultExport: {
	(
		props: RouteContext & {
			history: BrowserHistory;
		},
	): React.JSX.Element;
	displayName: string;
} = withRouter(LastVisitedProjectPageRedirect);
export default defaultExport;
